var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7201 17.3268C41.7477 17.706 41.7477 18.083 41.7477 18.46C41.7477 29.9975 33.1351 43.2922 17.3952 43.2922C12.546 43.2922 8.041 41.86 4.25 39.3727C4.9385 39.4528 5.6015 39.481 6.31762 39.481C10.319 39.481 14.0016 38.103 16.9447 35.7522C13.1814 35.672 10.0279 33.1587 8.93987 29.7007C9.469 29.7808 10.0002 29.835 10.557 29.835C11.3241 29.835 12.0955 29.7267 12.8116 29.5382C8.88675 28.7278 5.94787 25.2157 5.94787 20.9733V20.865C7.089 21.5128 8.41287 21.918 9.81537 21.9722C7.50975 20.4078 5.99887 17.732 5.99887 14.7052C5.99887 13.0845 6.42175 11.5982 7.16337 10.3025C11.3772 15.5957 17.7119 19.0558 24.8136 19.435C24.6819 18.785 24.6011 18.1112 24.6011 17.4352C24.6011 12.6252 28.4176 8.70782 33.1606 8.70782C35.6256 8.70782 37.8505 9.76082 39.4145 11.4638C41.3482 11.0847 43.2012 10.3545 44.846 9.35566C44.2106 11.3815 42.857 13.0845 41.0826 14.1657C42.806 13.975 44.4762 13.4897 46.0105 12.8137C44.846 14.5427 43.3904 16.0832 41.7201 17.3268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ec3cb7ca.svg";
export { ForwardRef as ReactComponent };